import React from 'react'

const softwares = [
  { name: "Construction Management", icon: "fa fa-building" },
  { name: "Stone Crusher Management", icon: "fa fa-cogs" },
  { name: "Milk Dairy Management", icon: "fa fa-tint" },
  { name: "Temple Devotee Management", icon: "fa fa-university" },
  { name: "Digital Management", icon: "fa fa-laptop" },
  { name: "ERP Billing Management", icon: "fa fa-calculator" },
  { name: "Hospital Management", icon: "fa fa-hospital" },
  { name: "Lodge/Hotel Management", icon: "fa fa-bed" },
  { name: "Restaurant/Bar Management", icon: "fa fa-utensils" },
  { name: "Laundry Management", icon: "fa fa-soap" },
]

function AvailableSoft() {
  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 text-center text-lg-start">
              <h1 className="display-4 text-white mb-4 animated slideInRight">Available Softwares</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="/index">Home</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Softwares</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                Bluevipers Technology offers a wide range of software solutions for businesses across various industries. 
                Choose the software that fits your needs and streamline your operations.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="Available Softwares" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>

      {/* Softwares Grid */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-4">
            {softwares.map((software, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden software-card">
                  <div className="card-body text-center py-5">
                    <div className="mb-4 icon-container">
                      <i className={`${software.icon} fa-3x text-white`}></i>
                    </div>
                    <h5 className="card-title mb-3 text-white">{software.name}</h5>
                    <p className="card-text text-white-50">
                      Efficient solution to manage your {software.name.toLowerCase()} operations smoothly.
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="container-fluid bg-primary py-5">
        <div className="container text-center">
          <h2 className="text-white mb-4">Interested in Our Software Solutions?</h2>
          <p className="text-white-50 mb-4">Contact Bluevipers Technology today to get a demo or request a quote.</p>
          <a href="/contact" className="btn btn-light rounded-pill px-4 py-2">Contact Now</a>
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .software-card {
          background: linear-gradient(135deg, #1b3889ff, #2d80f3ff);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .software-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.3);
        }
        .icon-container {
          width: 80px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          border-radius: 50%;
          background: rgba(255,255,255,0.2);
          transition: background 0.3s ease, transform 0.3s ease;
        }
        .icon-container:hover {
          background: rgba(255,255,255,0.35);
          transform: scale(1.2);
        }
      `}</style>
    </div>
  )
}

export default AvailableSoft
